/* unplugin-vue-components disabled */import script from "./StudyMaterialDetailTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudyMaterialDetailTop.vue?vue&type=script&lang=ts&setup=true"

import "./StudyMaterialDetailTop.vue?vue&type=style&index=0&id=0d074128&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d074128"]])

export default __exports__